module.exports = __webpack_public_path__ + "img/sass.d1247cd6.jpg";